import Bowser from 'bowser';

const userAgent = window.navigator.userAgent,
  BOWSER = Bowser.getParser(userAgent);

/**
 * Return is current browser is Safari
 * @returns boolean
 */
export const isSafari = (): boolean => {
  if (BOWSER.getBrowserName() === 'Safari') {
    return true;
  }
  return false;
};

/**
 * Chrome on an iOS device has some bugs that also occur on Safari, using this function to check if the browser is Chrome on iOS.
 * @returns boolean
 */
export const isChromeIos = (): boolean => {
  if (BOWSER.getBrowserName() === 'Chrome' && BOWSER.getOSName() === 'iOS') {
    return true;
  }
  return false;
};

/**
 * Check if the current operating system is iOS
 * @returns boolean
 */
export const isIOS = () => {
  return BOWSER.getOSName() === 'iOS';
};
